module.exports = __webpack_public_path__ + "img/3-1.5e225056.jpg";